import React from 'react';
import {useTranslation} from 'react-i18next';
import {FlatList, Text, View} from 'react-native';
import {staticNumberFormatter} from '../../../../utils/NumberFormatter';
import styles from './DebtFactor.styles';

function RowItem(props) {
  const {item, textStyle} = props;
  const {t} = useTranslation();

  return (
    <View style={styles.rowContainer}>
      <Text style={[styles.rowValue, textStyle]}>
        {staticNumberFormatter(item?.value)} {t('toman')}
      </Text>
      <Text style={[styles.title, textStyle]}>{item?.title}</Text>
    </View>
  );
}

export default function Factor(props) {
  const {amountPayable, arrayItems} = props;
  const {t} = useTranslation();

  return (
    <View style={styles.container}>
      <FlatList
        data={arrayItems}
        renderItem={({item}) => {
          return <RowItem item={item} />;
        }}
      />
      <RowItem
        item={{
          title: t('amount_payable'),
          value: amountPayable,
        }}
        textStyle={styles.amountPayable}
      />
    </View>
  );
}
